import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { convertParseDateTime } from 'src/app/shared/utils/utility.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-dashboard-default-card',
  templateUrl: './dashboard-default-card.component.html',
  styleUrls: ['./dashboard-default-card.component.scss'],
})
export class DashboardDefaultCardComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;

  @Input() iconPath: string | undefined;
  @Input() title: string | undefined;

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   *
   * @param time get time format
   * @returns return formated time
   */
  getContentFormatDate(time: string, format: 'hh:mma') {
    return convertParseDateTime(time, 't', format);
  }
}
